import { Routes } from '@angular/router';
import { HomeComponent } from '@home/components/home.component';
import { CarrierConfigurationsComponent } from '@carrier-configurations/carrier-configurations.component';
import { authGuard } from '@shared/services/auth.guard';
import { UnauthorizedComponent } from '@unauthorized/unauthorized.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    title: 'Home Page',
    canActivate: [authGuard],
    component: HomeComponent,
  },
  {
    path: 'carrier-configurations',
    title: 'Carrier Integrations',
    canActivate: [authGuard],
    component: CarrierConfigurationsComponent,
  },
  {
    path: 'unauthorized',
    title: 'Unauthorized',
    component: UnauthorizedComponent
  }
];
